import { useMemo } from 'react';
import { TabItem } from '../../components/components.interfaces';
import { ComplianceManagementProvider } from './contexts/complianceManagement.context';
import ComplianceManagementView from './subviews/complianceManagement/complianceManagement.view';
import { PageName } from '../../../utils/pages-helpers';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';
import { useRbacState } from 'src/context/rbac.context';
import { hasReadPermission } from 'src/utils/rbacHelpers';

export const settingsSubRouteIds = [
  // PageName.userManagement,
  PageName.complianceManagement,
];

export const useSettingsTabMenuItems = (
  translateText: TTranslateTextType
): TabItem[] => {
  const { rbac } = useRbacState();

  return useMemo(() => {
    const tabs: TabItem[] = [];

    // if (hasReadPermission(rbac, 'settings', 'userManagement')) {
    //   tabs.push({
    //     label: translateText('settings.tabs.userManagement'),
    //     onClickHandler: () => {},
    //     tabPanel: (
    //       <UserManagementProvider>
    //         <UserManagementView />
    //       </UserManagementProvider>
    //     ),
    //   });
    // }

    if (hasReadPermission(rbac, 'settings', 'complianceManagement')) {
      tabs.push({
        label: translateText('settings.tabs.complianceManagement'),
        onClickHandler: () => { },
        tabPanel: (
          <ComplianceManagementProvider>
            <ComplianceManagementView />
          </ComplianceManagementProvider>
        ),
      });
    }

    return tabs;
  }, [rbac, translateText]);
};

/** Returns route IDs for tabs the user has read permission for, in display order */
export const useSettingsAvailableRouteIds = (): string[] => {
  const { rbac } = useRbacState();
  return useMemo(() => {
    const routes: string[] = [];
    // if (hasReadPermission(rbac, 'settings', 'userManagement'))
    //   routes.push(PageName.userManagement);
    if (hasReadPermission(rbac, 'settings', 'complianceManagement'))
      routes.push(PageName.complianceManagement);
    return routes;
  }, [rbac]);
};

export const getSettingsTabIndex = (pathname: string) => {
  const settingsTabsIndexObject = {
    [PageName.userManagement]: 0,
    [PageName.complianceManagement]: 1,
  };

  const tabIndex =
    settingsTabsIndexObject[pathname as keyof typeof settingsTabsIndexObject];
  return tabIndex;
};

export const getSettingsSubRouteId = (index: number) =>
  settingsSubRouteIds[index];
